import { Field, Model } from "@junte/serialize-ts";
import { Entity } from "@core/api/entity";

@Model()
export class LabelledEntity extends Entity {
  @Field() label: string;
  @Field() uid: string;

  public static create(data: Partial<LabelledEntity>): LabelledEntity {
    return Object.assign(new LabelledEntity(), data);
  }
}
